import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { HomeFeedSwitcherProps } from './HomeFeedSwitcher';

const HomeFeedSwitcher = () => import(/* webpackChunkName: "4-feat-homefeed-switcher" */ './HomeFeedSwitcher');

const LoadableHomeFeedSwitcher: ComponentType<HomeFeedSwitcherProps> = lazyLoadOnRender({ loader: HomeFeedSwitcher });
export default LoadableHomeFeedSwitcher;
